import request from '@/utils/request'

// 获取消息推送列表
export function getList(data) {
  return request.get('/portConfig/list')
}

// 更新工程配置信息
export function updateOne(data) {
  return request.post('/portConfig/update', data)
}

